import { Injectable } from "@angular/core";
import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class PasswordService {
  passwordComplexityValidator(config: PasswordComplexity): ValidatorFn {
    return (control: AbstractControl<string>): ValidationErrors | null => {
      const newPassword = control.value;

      const errors: any = {};

      if (newPassword.length < config.length) {
        errors.minLength = {
          required: config.length,
          actual: newPassword.length,
        };
      }

      const numCount = (newPassword.match(/\d/g) || []).length;
      if (numCount < config.requiredNumbers) {
        errors.requiredNumbers = {
          required: config.requiredNumbers,
          actual: numCount,
        };
      }

      const symCount = (newPassword.match(/[^A-Za-z0-9]/g) || []).length;
      if (symCount < config.requiredSymbols) {
        errors.requiredSymbols = {
          required: config.requiredSymbols,
          actual: symCount,
        };
      }

      const capCount = (newPassword.match(/[A-Z]/g) || []).length;
      if (capCount < config.requiredCapitalLetters) {
        errors.requiredCapitalLetters = {
          required: config.requiredCapitalLetters,
          actual: capCount,
        };
      }

      const smallCount = (newPassword.match(/[a-z]/g) || []).length;
      if (smallCount < config.requiredSmallLetters) {
        errors.smallLetters = {
          required: config.requiredSmallLetters,
          actual: smallCount,
        };
      }

      return Object.keys(errors).length > 0
        ? { passwordComplexity: errors }
        : null;
    };
  }

  passwordsMustMatchValidator(): ValidatorFn {
    return (
      control: AbstractControl<{
        newPassword: string;
        newPasswordCheck: string;
      }>,
    ): ValidationErrors | null => {
      const { newPassword, newPasswordCheck } = control.value;
      if (!newPassword || !newPasswordCheck) {
        return null;
      }

      return newPassword == newPasswordCheck
        ? null
        : { passwordMismatch: true };
    };
  }

  defaultPasswordComplexity(): PasswordComplexity {
    return {
      length: 8,
      requiredCapitalLetters: 0,
      requiredNumbers: 1,
      requiredSmallLetters: 1,
      requiredSymbols: 0,
    };
  }
}

export type PasswordComplexity = {
  length: number;
  requiredNumbers: number;
  requiredSymbols: number;
  requiredCapitalLetters: number;
  requiredSmallLetters: number;
};
